export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_TO_CART = 'REMOVE_TO_CART'
export const CART_CLEAN = 'CART_CLEAN'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/cart/mutation-types.js
// module id = null
// module chunks = 